import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {documentsStore} from '@store/documents/documents.store';

export const getDocumentsDataSource = createRequestDataSource({
  store: documentsStore,
  data$: () => documentsStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getDocuments',
  dataKey: 'documents',
});
